import info from '@/api/info'
import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import Add from './add.dialog'
import help from '../../../../utils/help'

const columns = [
  {
    title: '',
    enTitle: 'Title',
    width: 200,
    dataIndex: 'name',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Tail Path',
    width: 120,
    dataIndex: 'code',
    slot: 'code'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 120,
    dataIndex: 'createTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    Add
  },
  data() {
    return {
      columns,
      params: {},
      dataSource: [],
      inputData: {},
      isVisable: false,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      user: 'getUser'
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })

      const { list, pageIndex, pageSize, total } = await info.get(data)
      this.dataSource = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    handleClear() {
      this.params = {}
      this.getList()
    },
    add() {
      this.inputData = ''
      this.isVisable = true
    },
    edit(val) {
      this.inputData = val
      this.isVisable = true
    },
    cancel() {
      this.isVisable = false
    },
    confirm() {
      this.isVisable = false
      this.getList()
    },
    async able(val) {
      const { id, released, version } = val
      await info.release(id, !released, { version })
      let content = 'This Info Page has been published!'
      if (released) {
        content = 'This Info Page has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this Info Page?',
        content:
          'Please be aware of once this Info Page is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await info.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Info Page has been deleted!'
        })
        this.getList()
      })
    },
    copy(val) {
      let url = `/info/${val}`
      const { host } = window.location
      if (
        host.includes('192.168.5') ||
        host.includes('192.168.4.34') ||
        host.includes('102.168.4.21') ||
        host.includes('localhost')
      ) {
        url = 'http://192.168.5.18:3020' + url
      } else if (
        host.includes('192.168.4.23') ||
        host.includes('imrpress.tech:9100')
      ) {
        url = 'http://www.imrpress.tech' + url
      } else if (host.includes('imrpress.tech:8100')) {
        url = 'http://www.imrpress.tech:9000' + url
      } else if (host.includes('propub.com')) {
        url = 'https://www.imrpress.com' + url
      } else {
        url = 'http://192.168.5.18:3020' + url
      }
      help.copyToBlock(url)
      this.$message.success({
        title: 'Success',
        content: 'The link has been copied to the clipboard!'
      })
    }
  }
}
